import { render, staticRenderFns } from "./v-row-col.vue?vue&type=template&id=ab725b32&scoped=true&"
import script from "./v-row-col.vue?vue&type=script&lang=js&"
export * from "./v-row-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab725b32",
  null
  
)

export default component.exports